import React from 'react';

const ProductRow = ({ product, onSelect, onDelete }) => {
  const fmt = (n) => (typeof n === 'number' ? `$${n.toFixed(2)}` : '$0.00');
  const fmtPct = (n) => (typeof n === 'number' ? `${(n * 100).toFixed(1)}%` : '—');
  const marginClass = (m) => m >= 0.3 ? 'margin-good' : m >= 0.15 ? 'margin-ok' : 'margin-low';

  const hasPricing = product.wholesale_price || product.retail_price;

  return (
    <div
      className={`product-row-main ${product.is_active ? 'is-active' : 'is-inactive'}`}
      onClick={() => onSelect(product, 'overview')}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onSelect(product, 'overview'); }}
    >
      <div className="col col-name">
        <span className="product-name">{product.flavor || 'Unknown'}</span>
        {hasPricing && (
          <span className="product-pricing">
            {product.wholesale_price ? `WS ${fmt(product.wholesale_price)}` : ''}
            {product.wholesale_price && product.retail_price ? ' · ' : ''}
            {product.retail_price ? `Ret ${fmt(product.retail_price)}` : ''}
          </span>
        )}
      </div>

      <div className="col col-cogs">{fmt(product.total_cogs)}</div>

      <div className="col col-margin">
        <span className={marginClass(product.wholesale_margin)}>{fmtPct(product.wholesale_margin)}</span>
      </div>

      <div className="col col-retail-margin">
        <span className={marginClass(product.retail_margin)}>{fmtPct(product.retail_margin)}</span>
      </div>

      <div className="col col-status">
        <span className={`status-badge ${product.is_active ? 'active' : 'inactive'}`}>
          {product.is_active ? 'Active' : 'Inactive'}
        </span>
      </div>

      <div className="col col-actions" onClick={(e) => e.stopPropagation()}>
        <div className="row-actions">
          <button
            className="action-btn edit-action"
            onClick={() => onSelect(product, 'edit')}
            title="Edit"
            aria-label={`Edit ${product.flavor}`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
          </button>
          <button
            className="action-btn delete-action"
            onClick={() => onDelete(product.id)}
            title="Delete"
            aria-label={`Delete ${product.flavor}`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductRow;
